import React, { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Snackbar, Alert } from "@mui/material";
import { RegistrationContext } from "../../context/registrationContext/RegistrationContext";
import { register } from "../../context/registrationContext/RegistrationApiCalls";
import { validateFiled } from "../../components/validation/Validation";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  margin-bottom: 30px;
`;

const Input = styled.input`
  padding: 5px;
  margin-bottom: 5px;
  font-size: 16px;
  border: none;
  border-bottom: 1px solid ${(props) => (props.error ? "red" : "gray")};
  color: ${(props) => (props.error ? "red" : "black")};
`;

const RegisterButton = styled.button`
  margin-top: 10px;
  padding: 7px 10px;
  border: none;
  border-radius: 5px;
  background-color: #88bfd3;
  color: white;
  font-weight: 600;
  cursor: pointer;
  height: 40px;
  width: 100%;
  align-self: center;
  &:disabled {
    background-color: lightgray;
  }
`;

const Register = () => {
  const navigate = useNavigate();

  const { userId } = useParams();
  const { registrationInfo, error, isFetching, dispatch } =
    useContext(RegistrationContext);

  let phone = registrationInfo ? registrationInfo.phoneNumber : "";
  let email = registrationInfo ? registrationInfo.email : "";
  let name = registrationInfo ? registrationInfo.name : "";

  const [contactPerson, setContactPerson] = useState(name);
  const [phoneNumber, setPhoneNumber] = useState(phone);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [errorText, setErrorText] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  if (isFetching && !registrationInfo) {
    return <div>loading...</div>;
  }

  if ((!isFetching && !registrationInfo) || error) {
    navigate("/login");
  }

  if (!isFetching && registrationInfo) {
    //setPhoneNumber(registrationInfo.phoneNumber);
  }

  const validate = () => {
    //return false if error
    setPasswordError(false);
		setPhoneError(false);
		setNameError(false);

		let validationResult = true;

    if (password !== passwordConfirm) {
      setErrorText("Passwords are not matching.");
      setPasswordError(true);
			validationResult = false;
    }

    if (!validateFiled(password)) {
      setErrorText("Password is mandatory.");
      setPasswordError(true);
			validationResult = false;
    }

    if (!validateFiled(phoneNumber)) {
      setErrorText("Phone number is mandatory.");
      setPhoneError(true);
			validationResult = false;
    }

		if (!validateFiled(contactPerson)) {
      setErrorText("Name is mandatory.");
      setNameError(true);
			validationResult = false;
    }

		return validationResult;
  };

  const handleRegister = (e) => {
    e.preventDefault();
		if(!validate()){
			return;
		}
		
    register(userId, { email, contactPerson, phoneNumber, password }, dispatch).then(() => {
      navigate("/login");
    });
  };

  return (
    <Container>
      <Snackbar
        open={error || passwordError || phoneError}
        autoHideDuration={1000}
        //onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorText}
        </Alert>
      </Snackbar>
      <Form>
        <Title>Aradas Customer Portal</Title>
        <Input
          readOnly
					disabled
          type="text"
          value={registrationInfo.salesforceAccountName}
        />
        <Input
          type="text"
          placeholder="Name*"
          error={nameError || error}
          value={contactPerson}
          onChange={(e) => setContactPerson(e.target.value)}
        />
        <Input
          type="text"
          placeholder="Phone Number*"
          error={phoneError || error}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <Input
          readOnly
          type="text"
          placeholder="email*"
          autocomplete="username email"
					disabled
          value={registrationInfo.email}
        />
        <Input
          type="password"
          placeholder="Password*"
					autoComplete="new-password"
          error={passwordError || error}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Input
          type="password"
          placeholder="Confirm Password*"
					autoComplete="new-password"
          error={passwordError || error}
          onChange={(e) => setPasswordConfirm(e.target.value)}
        />
        <RegisterButton onClick={handleRegister} disabled={isFetching}>
          Register
        </RegisterButton>
      </Form>
    </Container>
  );
};

export default Register;
